import React from 'react';
import PropTypes from 'prop-types';
import {
  FiHome, FiList, FiClock, FiPackage, FiDollarSign, FiTrendingUp,
} from 'react-icons/fi';
import { NavLink } from 'react-router-dom';

function SalesMenu({ closeMenu }) {
  const handleClick = () => {
    if (closeMenu) closeMenu(); // only used on mobile
  };

  return (
    <div className="bg-gray-800 text-white w-64 min-h-screen p-4 flex flex-col">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-xl font-bold p-2 border-b border-gray-700 flex items-center">
          <FiPackage className="mr-2" />
          Sales System
        </h2>
      </div>

      {/* Navigation */}
      <nav className="flex-1">
        <ul className="space-y-1">
          <MenuItem
            onClick={handleClick}
            to="/sales/dashboard"
            icon={<FiHome />}
            label="Dashboard"
          />
          <MenuItem
            onClick={handleClick}
            to="/sales/entry"
            icon={<FiDollarSign />}
            label="New Sale"
          />
          <MenuItem
            onClick={handleClick}
            to="/sales/update-entry/:orderId"
            icon={<FiDollarSign />}
            label="Update Sale"
          />
          <MenuItem
            onClick={handleClick}
            to="/sales/analytics"
            icon={<FiTrendingUp />}
            label="Analytics"
          />
          <MenuItem
            onClick={handleClick}
            to="/sales/transactions"
            icon={<FiList />}
            label="Sales History"
          />
          <MenuItem
            onClick={handleClick}
            to="/sales/future-plans"
            icon={<FiClock />}
            label="Future Plans"
          />
        </ul>
      </nav>

      {/* User Section */}
      <UserProfile />
    </div>
  );
}

// Extracted Menu Item Component
function MenuItem({
  to, icon, label, onClick,
}) {
  return (
    <li>
      <NavLink
        to={to}
        onClick={onClick}
        className={({ isActive }) => `flex items-center p-2 rounded transition ${
          isActive
            ? 'bg-blue-600 text-white'
            : 'hover:bg-gray-700'
        }`}
      >
        <span className="mr-3">{icon}</span>
        {label}
      </NavLink>
    </li>
  );
}

// Extracted User Profile Component
function UserProfile() {
  return (
    <div className="pt-4 border-t border-gray-700">
      <div className="flex items-center p-2">
        <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-2">
          <span className="text-sm font-medium">AD</span>
        </div>
        <div>
          <p className="text-sm font-medium">Admin User</p>
          <p className="text-xs text-gray-400">Sales Manager</p>
        </div>
      </div>
    </div>
  );
}

// PropTypes

// props validation for SalesMenu
SalesMenu.propTypes = {
  closeMenu: PropTypes.func, // optional, used for mobile drawer
};
// props validation for MenuItem (to, icon, label,  onclick)
MenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

// Default props to satisfy react/require-default-props
SalesMenu.defaultProps = {
  closeMenu: () => {},
};

// default props for onclick
MenuItem.defaultProps = {
  onClick: () => {},
};

export default SalesMenu;
